<div class="table-responsive text-center">
  <table class="table table-sm" style="color: unset;">
    <thead>
      <tr>
        <th class="text-left">Lesson</th>
        <th *ngIf="!short">Start / End</th>
        <th *ngIf="!short">Headword</th>
        <th *ngIf="!short">Reading</th>
        <th *ngIf="!short">Dict</th>
        <th *ngIf="short">Progress</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let historyItem of progressHistory">
        <td class="text-left">
          {{getHistoryItemHeader(historyItem)}}<br/>
          <small class="text-muted" *ngIf="getLessonType(historyItem)">{{getLessonType(historyItem)}},</small><small class="text-muted">{{getCreated(historyItem) | date: 'EEE dd MMM HH:mm'}}, {{getAttendance(historyItem)}}</small>
          <small class="text-muted" *ngIf="historyItem.details.comment"><br/>comment: {{historyItem.details.comment}}</small>
        </td>
        <td *ngIf="!short">
          {{getStart(historyItem)}} / {{getPara(historyItem)}}
        </td>
        <td *ngIf="!short">
          {{getHw(historyItem)}}
        </td>
        <td *ngIf="!short">
          <span *ngIf="getReadingLesson(historyItem)">{{getReadingLesson(historyItem)}}</span>
          <small *ngIf="getReading(historyItem)"><br/>({{getReading(historyItem)}})</small>

        </td>
        <td *ngIf="!short">
          {{getDict(historyItem)}}
        </td>
        <td *ngIf="short" [innerHTML]="getProgress(historyItem)">
        </td>
      </tr>
      <tr >
        <td colspan="6" *ngIf="!isLastPage()">
          <a tabindex="" class="cursor-pointer" (click)="nextHistoryPage()"><i class="fa fa-chevron-down"></i></a>
        </td>
      </tr>
    </tbody>
  </table>
</div>
